import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Images/Logo.png';
import '../index.css';

const NavigationBar = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [showDropdown, setshowDropdown] = useState(false);

  const isActive = (path) => location.pathname === path;

  const closeMenu = () => {
    setExpanded(false);
    setshowDropdown(false);
  };

  const handleMouseEnter = () => {
    if (window.innerWidth >= 992) {
      setshowDropdown(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth >= 992) {
      setshowDropdown(false);
    }
  };

  return (
    <Navbar
      expand="lg"
      bg="dark"
      variant="dark"
      sticky="top"
      
      expanded={expanded}
      className="navbar-custom"
    >
      <Container className="text-white fs-5 justify-content-between">
        <Navbar.Brand as={Link} to="/" onClick={closeMenu}>
          <img
            className="d-inline-block align-top"
            src={logo}
            alt="logo"
            style={{ height: '80px', width: 'auto' }}
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={() => setExpanded(!expanded)}
          className={expanded ? 'toggle-icon open' : 'toggle-icon'}
        />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto nav-gap align-items-center">
            <Nav.Link as={Link} to="/" onClick={closeMenu} className={isActive('/') ? 'nav-link-active' : ''}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={closeMenu} className={isActive('/about') ? 'nav-link-active' : ''}>
              About
            </Nav.Link>

            <NavDropdown
              title={
                <>
                  Products <i className="fas fa-chevron-down ms-1"></i>
                </>
              }
              id="products-dropdown"
              show={showDropdown}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={() => {
                if (window.innerWidth < 992) {
                  setshowDropdown(!showDropdown);
                }
              }}
              className={location.pathname.startsWith('/products') ? 'nav-link-active' : ''}
            >
              <NavDropdown.Item
                as={Link}
                to="/products/cement-raw-materials"
                onClick={closeMenu}
                className={location.pathname === '/products/cement-raw-materials' ? 'active' : ''}
              >
                Cement Raw Materials & Equipments
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/products/raw-mill"
                onClick={closeMenu}
                className={location.pathname === '/products/raw-mill' ? 'active' : ''}
              >
                Raw mill & Conveyors Equipments
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/products/cement-production"
                onClick={closeMenu}
                className={location.pathname === '/products/cement-production' ? 'active' : ''}
              >
                Cement Production & Equipments
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/products/cement-equipments"
                onClick={closeMenu}
                className={location.pathname === '/products/cement-equipments' ? 'active' : ''}
              >
                Cement Equipments & Storage
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/cement" onClick={closeMenu} className={isActive('/cement') ? 'nav-link-active' : ''}>
              Cement
            </Nav.Link>
            <Nav.Link as={Link} to="/download-brochure" onClick={closeMenu} className={isActive('/download-brochure') ? 'nav-link-active' : ''}>
              Download Brochure
            </Nav.Link>

            <Nav.Link as={Link} to="/coporate-governance" onClick={closeMenu} className={isActive('/coporate-governance') ? 'nav-link-active' : ''}>
              Coporate Governance
            </Nav.Link>

            <Nav.Link as={Link} to="/why-us" onClick={closeMenu} className={isActive('/why-us') ? 'nav-link-active' : ''}>
              Why Us
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={closeMenu} className={isActive('/contact') ? 'nav-link-active' : ''}>
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
